export const LOCATION_INPUT_DEBOUNCE_MS = 500;
